// Search functionality
document.addEventListener('DOMContentLoaded', () => {
  
   const searchInput = document.querySelector('.search-modal input');
   const searchModal = document.querySelector('.search-modal');
   const searchButtons = document.querySelectorAll('.search-button');
   const closeSearchButton = document.querySelector('.close-search');
   const authModal = document.querySelector('.auth-modal');
   let searchTimeout;
   const MAX_RESULTS = 9;

   // Function to show search modal
   const showSearchModal = () => {
      searchModal.classList.remove('hidden');
      searchInput.focus();
   };

   // Function to hide search modal
   const hideSearchModal = () => {
      searchModal.classList.add('hidden');
      searchInput.value = '';
      const existingResults = searchModal.querySelector('.search-results');
      if (existingResults) {
         existingResults.remove();
      }
   };

   // Function to handle search input
   const handleSearch = async (query) => {
      if (!query) {
         // Clear results if query is empty
         const existingResults = searchModal.querySelector('.search-results');
         if (existingResults) {
         existingResults.remove();
         }
         return;
      }

      try {
         // Make API request to Shopify search endpoint (respect current locale root)
         const rootUrl = searchModal?.dataset?.rootUrl || '';
         const url = new URL(window.location.href);
         const basePath = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
         url.pathname = `${basePath}/search/suggest.json`;
         url.search = '';
         url.searchParams.set('q', query);
         url.searchParams.append('resources[type]', 'product');
         const response = await fetch(url.toString());
         const data = await response.json();
         
         // Handle the search results
         displaySearchResults(data, query);
      } catch (error) {
         console.error('Search error:', error);
      }
   };

   // Function to display search results
   const displaySearchResults = (data, query) => {
      // Clear previous results
      const existingResults = searchModal.querySelector('.search-results');
      if (existingResults) {
         existingResults.remove();
      }

      // Create results container
      const resultsContainer = document.createElement('div');
      resultsContainer.className = 'search-results mt-4 grid grid-cols-2 gap-4 lg:grid-cols-3';

      // Add products to results
      if (data.resources?.results?.products) {
         const products = data.resources.results.products;
         
         // Limit to MAX_RESULTS
         const displayProducts = products.slice(0, MAX_RESULTS);
         
         if (displayProducts.length === 0) {
            const noResultsContainer = document.createElement('div');
            noResultsContainer.className = 'col-span-2 text-center py-8 lg:col-span-3';
            const titleTpl = searchModal?.dataset?.i18nNoResultsTitle || 'No results found for "__QUERY__"';
            const subtitleTpl = searchModal?.dataset?.i18nNoResultsSubtitle || 'Try checking your spelling or using more general terms';
            const title = titleTpl.replace('__QUERY__', query);
            const subtitle = subtitleTpl;
            noResultsContainer.innerHTML = `
               <p class="text-lg mb-2">${title}</p>
               <p class="text-sm text-gray-600">${subtitle}</p>
            `;
            resultsContainer.appendChild(noResultsContainer);
         } else {
            displayProducts.forEach(product => {
               // Create product container
               const productContainer = document.createElement('div');
               productContainer.className = 'product-item';
               
               // Create link
               const productLink = document.createElement('a');
               productLink.href = product.url;
               productLink.className = 'group flex flex-col gap-4';
               
               // Create image container
               const imageContainer = document.createElement('div');
               imageContainer.className = 'relative';
               
               // Add hover image if available
               if (product.images && product.images.length > 1) {
                  const hoverImage = document.createElement('img');
                  hoverImage.className = 'aspect-4/5 absolute w-full rounded-lg opacity-0 transition-opacity duration-200 group-hover:opacity-100';
                  hoverImage.src = product.images[1].url;
                  hoverImage.alt = product.title;
                  hoverImage.width = 500;
                  hoverImage.height = 500;
                  imageContainer.appendChild(hoverImage);
               }
               
               // Add main image
               const mainImage = document.createElement('img');
               mainImage.className = 'aspect-4/5 w-full rounded-lg';
               mainImage.src = product.featured_image.url;
               mainImage.alt = product.title;
               mainImage.width = 500;
               mainImage.height = 500;
               imageContainer.appendChild(mainImage);
               
               // Create product info container
               const infoContainer = document.createElement('div');
               infoContainer.className = 'grid justify-between gap-2 px-5';
               
               // Create title container
               const titleContainer = document.createElement('div');
               titleContainer.className = 'grid gap-2';
               
               // Split title if it contains a bullet point
               const titleParts = product.title.split(' • ');
               if (titleParts.length > 1) {
                  const title = document.createElement('h3');
                  title.className = 'text-base font-medium leading-none';
                  title.textContent = titleParts[0];
                  
                  const subtitle = document.createElement('p');
                  subtitle.className = 'text-base leading-none';
                  subtitle.textContent = titleParts[1];
                  
                  titleContainer.appendChild(title);
                  titleContainer.appendChild(subtitle);
               } else {
                  const title = document.createElement('h3');
                  title.className = 'text-base font-medium';
                  title.textContent = product.title;
                  titleContainer.appendChild(title);
               }
               
               // Create price
               const price = document.createElement('p');
               price.className = 'text-base font-medium leading-none';
               
               // Debug logging
               console.log('Product:', product);
               console.log('Variants:', product.variants);
               if (product.variants && product.variants[0]) {
                  console.log('First variant:', product.variants[0]);
                  console.log('Selling plan allocations:', product.variants[0].selling_plan_allocations);
               }
               
               // Check if product has a price range (indicating subscription options)
               if (product.price_min !== product.price_max) {
                  const subscriptionPrice = product.price_min * 0.8; // Deduct 20%
                  price.textContent = `From ${CurrencyUtils.formatMoney(subscriptionPrice * 100)}`;
               } else {
                  price.textContent = CurrencyUtils.formatMoney(product.price * 100);
               }
               
               // Assemble the product card
               infoContainer.appendChild(titleContainer);
               infoContainer.appendChild(price);
               
               productLink.appendChild(imageContainer);
               productLink.appendChild(infoContainer);
               
               productContainer.appendChild(productLink);
               resultsContainer.appendChild(productContainer);
            });
            
            // Add "View all results" link if there are more products
            if (products.length > MAX_RESULTS) {
               const viewAllContainer = document.createElement('div');
               viewAllContainer.className = 'col-span-2 mt-6 flex justify-center lg:col-span-3';
               
               const viewAllLink = document.createElement('a');
               const rootUrl = searchModal?.dataset?.rootUrl || '';
               const viewAllUrl = new URL(window.location.href);
               const basePath2 = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
               viewAllUrl.pathname = `${basePath2}/search`;
               viewAllUrl.search = '';
               viewAllUrl.searchParams.set('q', query);
               viewAllUrl.searchParams.set('type', 'product');
               viewAllLink.href = viewAllUrl.toString();
               viewAllLink.className = 'button black';
               const viewAllTpl = searchModal?.dataset?.i18nViewAllResults || 'View all __COUNT__ results';
               viewAllLink.textContent = viewAllTpl.replace('__COUNT__', products.length);
               
               viewAllContainer.appendChild(viewAllLink);
               resultsContainer.appendChild(viewAllContainer);
            }
         }
      } else {
         // No results at all
         const noResultsContainer = document.createElement('div');
         noResultsContainer.className = 'col-span-2 text-center py-8 lg:col-span-3';
         noResultsContainer.innerHTML = `
            <p class="text-lg mb-2">No results found for "${query}"</p>
            <p class="text-sm text-gray-600">Try checking your spelling or using more general terms</p>
         `;
         resultsContainer.appendChild(noResultsContainer);
      }

      // Add results to modal
      searchModal.appendChild(resultsContainer);
   };

   // Add input event listener with debounce
   searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
         handleSearch(e.target.value);
      }, 300);
   });

   // Show search modal when search button is clicked
   searchButtons.forEach(button => {
      button.addEventListener('click', (e) => {
         e.preventDefault();
         showSearchModal();
      });
   });

   // Hide search modal when close button is clicked
   closeSearchButton.addEventListener('click', (e) => {
      e.preventDefault();
      hideSearchModal();
   });

   // Close search modal when clicking outside
   document.addEventListener('click', (e) => {
      // Don't close if clicking on the search modal, search button, or auth modal
      if (!searchModal.contains(e.target) && 
         !e.target.closest('.search-button') && 
         !authModal.contains(e.target)) {
         hideSearchModal();
      }
   });

   // Handle escape key to close modal
   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
         // Check if auth modal is open
         const isAuthModalOpen = authModal && !authModal.classList.contains('hidden');
         
         // Only close search modal if auth modal is not open
         if (!isAuthModalOpen && !searchModal.classList.contains('hidden')) {
         hideSearchModal();
         }
      }
   });
});
